


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// import {UiMonths} from "../date-time/UiMonths";
import moment = require('moment');
@Component({
  name: 'ui-hours',
})
export default class UiHours extends Vue {
  @Prop({ default: () => new Date(), type: Date })
  date: Date;
  @Prop({ type: Function })
  allowedToShowView: Function;

  innerHours: any[] = [];
  innerMonth = this.date.getMonth();
  innerYear = this.date.getFullYear();
  innerDay = this.date.getDate();
  innerHour = this.date.getHours();

  mounted() {
    this.setDay(this.date);
    for (let index = 0; index < 24; index++) {
      this.innerHours.push({
        name:
          index.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
          }) + ':00',
        number: index,
        type: index == this.innerHour ? 'current' : '',
      });
    }
  }

  // getMonths() {
  //   return this.months.map(function(item, index) {
  //     return { number: index, name: item };
  //   });
  // }

  setDay(date: Date) {
    this.innerDay = date.getDate();
  }
  next() {
    this.setDay(new Date(this.innerYear, this.innerMonth, this.innerDay + 1));
  }
  backward() {
    this.setDay(new Date(this.innerYear, this.innerMonth, this.innerDay - 1));
  }
  changeHour(hour: any) {
    if (hour.type == '') {
      this.clearHours();
      hour.type = 'current';
    }
    this.innerHour = hour.number;
    this.$emit('changeHour', new Date(this.innerYear, this.innerMonth, this.innerDay, hour.number, 0));
  }
  changeDays() {
    this.$emit('onNavigation');
  }
  clearHours() {
    for (let index = 0; index < this.innerHours.length; index++) {
      if (this.innerHours[index].type == 'current') {
        this.innerHours[index].type = '';
      }
    }
  }
  openDays() {
    this.$emit('changeCurrentView', 'days');
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-date-picker/src/ui-hours.vue